import { useCallback } from 'react';

import { useIntl } from 'react-intl';

import Tooltip from '@mui/material/Tooltip';
import IconButton from '@mui/material/IconButton';
import DeleteForeverOutlinedIcon from '@mui/icons-material/DeleteForeverOutlined';

import ConfirmationDialog from 'src/components/ConfirmationDialog';
import { useMarkAccountDeleted } from 'src/pages/GatekeeperPage/api';
import {
  ADMIN_DELETION_COMMENT,
  ADMIN_DELETION_REASON_CODE,
} from 'src/pages/CandidatesPage/api/mutations/useDeleteCandidate';

import messages from 'src/pages/GatekeeperPage/messages';

type DeleteUserAccountButtonProps = {
  userUuid: string;
};

export default function DeleteUserAccountButton({
  userUuid,
}: DeleteUserAccountButtonProps) {
  const { formatMessage } = useIntl();
  const { mutate: markDeleted, isPending } = useMarkAccountDeleted();

  const handleConfirm = useCallback(() => {
    markDeleted({
      candidateUuid: userUuid,
      reasonCode: ADMIN_DELETION_REASON_CODE,
      comment: ADMIN_DELETION_COMMENT,
    });
  }, [markDeleted, userUuid]);

  return (
    <ConfirmationDialog
      maxWidth="sm"
      onConfirm={handleConfirm}
      message={formatMessage(messages.deleteUserAccountConfirmMessage)}
    >
      {(handleOpen) => (
        <Tooltip title={formatMessage(messages.deleteUserAccountHint)}>
          <IconButton onClick={handleOpen} disabled={isPending}>
            <DeleteForeverOutlinedIcon fontSize="small" />
          </IconButton>
        </Tooltip>
      )}
    </ConfirmationDialog>
  );
}
